<script setup>
import { ref, onMounted } from 'vue'
import { useCommon } from '../composable/useCommon.js'

const props = defineProps({
  isWebViewProp: { type: Boolean, default: false }
})

const { isWebView } = useCommon()
const isWebViewFlag = ref(props.isWebViewProp)

onMounted(() => {
  isWebViewFlag.value = isWebView()
})
</script>
<template>
  <footer class="footer">
    <div
      v-if="!isWebViewFlag"
      class="links"
    >
      <a
        class="link"
        href="https://jp.weathernews.com/"
      >会社概要</a>
      <a
        class="link"
        href="https://weathernews.jp/ip/kiyaku/"
      >利用規約</a>
      <a
        class="link"
        href="https://jp.weathernews.com/privacy-policy/"
      >プライバシーポリシー</a>
      <a
        class="link"
        href="https://weathernews.jp/ip/kiyaku/torihikihou.html"
      >特定商取引法の表記</a>
      <a
        class="link"
        href="https://weathernews.jp/ip/outtraffic/web.html"
      >外部送信先</a>
      <a
        class="link"
        href="https://weathernews.com/jp/c/terms/"
      >ご利用に際して</a>
      <a
        class="link"
        href="https://weathernews.jp/s/faq_v2/"
      >よくある質問</a>
      <a
        class="link"
        href="https://weathernews.jp/sitemap/"
      >サイトマップ</a>
    </div>
    <p class="copyright">
      ウェザーニュース
    </p>
  </footer>
</template>

<style lang="scss">
.footer {
  margin-top: 30px;
  margin-bottom: 100px;
  text-align: center;
  .links {
    display: flex;
    justify-content: space-between;
    padding-bottom: 10px;
    border-bottom: solid 1px #c0c0c0;
    overflow-x: scroll;
  }
  .link {
    padding-left: 8px;
    padding-right: 8px;
    color: #3569c0;
    font-size: 13px;
    font-weight: 700;
    line-height: 15px;
    white-space: nowrap;
    &:not(:last-child) {
      border-right: solid 1px #909090;
    }
  }
  .copyright {
    padding-top: 15px;
    padding-bottom: 15px;
    color: #666;
    font-size: 15px;
    line-height: 23px;
    background-color: #fff;
  }
  @media screen and (min-width: 830px) {
    .links {
      overflow: visible;
      justify-content: center;
    }
    .link {
      transition: opacity .2s ease-in-out;
      &:hover {
        opacity: .6;
      }
    }
  }
}
</style>
